import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5E742652-9430-4B8E-9C4C-19F326A74523
 * name mirror-variant
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mirror-variant.svg
 * tags
 * - Home Automation 
 */
export const MirrorVariantIcon = createSvgIcon(<><path d="M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61M14.17 3L18 6.83V17.17L14.17 21H9.83L6 17.17V6.83L9.83 3H14.17M15 1H9L4 6V18L9 23H15L20 18V6L15 1Z" /></>, 'MirrorVariantIcon');
export default MirrorVariantIcon